import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { untilDestroyed } from '@ngneat/until-destroy';
import { first } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { BaseWizardComponent } from '../base-wizard.component';
import { ChannelDimensionsModel, IChannelDimensionsModel, IChannelDimensionsDataModel } from '../models/veg-wizard-models';
import { ChannelDimensionsService } from '../services/channel-dimensions.service';
import { UtilService } from '../services/util.service';
import { VegWizardDataService } from '../services/veg-wizard-data.service';
import { GlobalValidationMessageComponent } from 'src/app/shared/global-validation-message/global-validation-message.component';

@Component({
  selector: 'app-channel-dimensions',
  templateUrl: './channel-dimensions.component.html',
  styleUrls: ['./channel-dimensions.component.css'],
  imports: [
    ReactiveFormsModule,
    GlobalValidationMessageComponent
],
})
export class ChannelDimensionsComponent extends BaseWizardComponent implements OnInit {
  form: FormGroup;
  nextButtonClicked = false;
  sessionId = '';
  widthMax: number;
  changeDimensionsData: IChannelDimensionsModel;
  isWidthPresentValid = false;
  isWidthRangeValid = false;
  isWidthRangeMaxValid = false;
  isWidthValid = false;

  constructor(
    private formBuilder: FormBuilder,
    private vwds: VegWizardDataService,
    private sessionService: SessionService,
    private channelDimensionsService: ChannelDimensionsService,
    private utilService: UtilService,
    router: Router
  ) {
    super();
    this.sessionId = sessionService.getSessionIdOrError();
    this.widthMax = 0;
    this.changeDimensionsData = vwds.getChannelDimensions() ?? new ChannelDimensionsModel();

    this.form = this.formBuilder.group({
      width: [this.changeDimensionsData?.width]
    });
  }

  ngOnInit(): void {

    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.changeDimensionsData.width = this.form.controls['width'].value;

      this.checkValidation();
    });

    this.channelDimensionsService.getChannelDimensions$(this.sessionId)
      .subscribe((data) => {
        this.widthMax = data.maxWidth;
        this.checkValidation();
      });
  }

  checkValidation() {
    this.form.controls['width']?.setErrors(null);

    this.isWidthPresentValid = this.widthPresentValid();
    this.isWidthRangeValid = this.widthRangeValid();
    this.isWidthRangeMaxValid = this.widthRangeMaxValid();
    this.isWidthValid = (this.isWidthPresentValid && this.isWidthRangeValid && this.isWidthRangeMaxValid);
    this.updateExchangeAreaRequired();

    if (!this.isWidthValid)
      this.form.controls['width']?.setErrors({ 'Error': true });
  }

  widthPresentValid(): boolean {
    return !!this.changeDimensionsData.width || this.changeDimensionsData.width === 0;
  }

  widthRangeValid(): boolean {
    return this.changeDimensionsData.width == null || this.changeDimensionsData.width > 0;
  }

  widthRangeMaxValid(): boolean {
    return this.changeDimensionsData.width == null || this.changeDimensionsData.width <= this.widthMax;
  }

  validateWidth() {
    this.updateExchangeAreaRequired();
  }

  updateExchangeAreaRequired() {
    if (this.changeDimensionsData.width != null) {
      this.changeDimensionsData.exchangeAreaRequired = this.changeDimensionsData.width > 10;
    }
  }

  override next() {

    this.form.markAsDirty();
    this.nextButtonClicked = true;

    if (this.form.invalid) {
      this.utilService.getFormValidationErrors(this.form);
      return;
    }

    const model = {} as IChannelDimensionsDataModel;
    model.sessionKey = this.sessionId;
    model.width = this.changeDimensionsData.width;
    model.length = 0;

    this.vwds
      .setChannelDimensions$(model)
      .pipe(first(), untilDestroyed(this))
      .subscribe((success) => {
        if (success) {
          super.next();
        }
      });
  }

}
